'use strict';

var types = {
  album: 'album',
  artist: 'artist',
  audioClip: 'audioClip',
  category: 'category',
  container: 'container',
  link: 'link',
  program: 'program',
  prompt: 'prompt',
  station: 'station',
  topic: 'topic',
  user: 'user'
};

var guideIdPrefixTypeMap = {
  a: types.category,
  c: types.category,
  d: types.album,
  g: types.category,
  i: types.audioClip,
  m: types.artist,
  p: types.program,
  r: types.category,
  s: types.station,
  t: types.topic,
  u: types.user
};

var guideIdUtils = {
  sanitize: function sanitize(guideId) {
    // TODO: More thorough sanitization here.  Should null if invalid guide id.
    return !guideId || guideId === 'o0' ? null : guideId;
  },
  types: types,
  guideIdPrefixTypeMap: guideIdPrefixTypeMap,
  getType: function getType(guideId) {
    return guideId ? this.guideIdPrefixTypeMap[guideId[0]] : null;
  },
  extractTypedGuideIds: function extractTypedGuideIds(guideId, container) {
    var guideIdType = this.getType(guideId);

    var ret = container || {};
    if (guideId && guideIdType) {
      ret[guideIdType + 'Id'] = guideId;
      return ret;
    }

    return ret;
  }
};

module.exports = guideIdUtils;